import Typography from '@mui/material/Typography'

export default function AiDisclaimer({text}: {text: string}) {
    return (
        <Typography
            style={{width: '50%', margin: '8px auto 0'}}
            variant="body2"
            sx={{
                fontFamily: 'Inter',
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '100%',
                letterSpacing: '0%',
                textAlign: 'center',
                color: '#5E5E5E',
            }}
        >
            {text}
        </Typography>
    )
}
